import {Moment} from 'moment';
import React from 'react';

import {
  CalendarFilesByDate,
  CalendarInteraction,
  CalendarItem,
  LayeredCalendarItems,
} from 'calendar/CalendarConstants';

import WeekComponent from './WeekComponent';
import WeeklyFileActivity from './WeeklyFileActivity';

interface CalendarWeekProps {
  today: Moment;
  weekStart: Moment;
  interact: CalendarInteraction;
  showWeeklyFileActivity?: boolean;
  files: CalendarFilesByDate;
  items: LayeredCalendarItems<CalendarItem>;
}

function CalendarWeek({
  files,
  interact,
  items,
  showWeeklyFileActivity = true,
  today,
  weekStart,
}: CalendarWeekProps): JSX.Element {
  return (
    <div>
      <WeekComponent
        today={today}
        weekStart={weekStart}
        items={items}
        interact={interact}
        renderDate={(date) => <span title={date.format('YYYY-MM-DD')}>{date.format('D')}</span>}
      />
      {showWeeklyFileActivity && <WeeklyFileActivity files={files} weekStart={weekStart} />}
    </div>
  );
}

export default CalendarWeek;
